import React, { ComponentProps } from 'react';
import { IconButton } from './button-circle-icon.styles';
import { Button } from '@vtbhome/juicyfront';

export const IconCircleButton: React.FC<ComponentProps<typeof Button>> = ({ children, ...props }) => {
    return (
        <IconButton buttonType='icon-round' {...props}>
            {children}
        </IconButton>
    );
};
